import { render, staticRenderFns } from "./AddLicenseType.vue?vue&type=template&id=7b340080&"
import script from "./AddLicenseType.vue?vue&type=script&lang=js&"
export * from "./AddLicenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports